import { useMutation, useQueryClient } from "react-query";
import { addNewDealer } from "../requests/addNewDealer";

export default function useAddNewDealer(queryKey: string) {
  const queryClient = useQueryClient();

  return useMutation(addNewDealer, {
    onSuccess: (data) => {
      window.location.href = `/dealers/${data.id}`;
      queryClient.invalidateQueries(queryKey);
    },
    onError: (error) => {
      console.error("Ошибка добавления нового дилера:", error);
    },
  });
}
